class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    this.numberOfProducts = 5;

    this.setProductsOnLocalStorage(this.product);
    this.createHTMLListElement();
  }

  get product() {
    return {
      id: this.getAttribute("data-product-id"),
      title: this.getAttribute("data-product-title"),
      url: this.getAttribute("data-product-url"),
      image: this.getAttribute("data-product-image"),
      price: this.getAttribute("data-product-price"),
      comparePrice: this.getAttribute("data-product-compare-price"),
    };  
  }

  get localStorageProducts() {
    return localStorage.getItem("deployer:recentlyViewedProduct");
  }

  /**
   * @param {Object} currentProduct
   */
  setProductsOnLocalStorage(currentProduct = this.product) {
    let productList = JSON.parse(this.localStorageProducts) || [];
    const isProductPresent = productList.some(product => { product.id === currentProduct.id });

    if (!isProductPresent) {
      productList.unshift(currentProduct);
  
      if (productList.length > this.numberOfProducts) {
        productList = productList.slice(0, this.numberOfProducts);
      }
  
      localStorage.setItem("deployer:recentlyViewedProduct", JSON.stringify(productList));
    }

  }
  
  formatPrice(price) {
    return (parseInt(price) / 100).toFixed(2) + window.variantStrings.moneyFormat.replace('{{ amount_no_decimals }}', '');
  }

  formatTitle(title) {
    let current_title = title.split('-');
    let elements = '';
    
    for (let i = 0; i < current_title.length; i++) {
      if (i === 0) {
        elements += `<span class="card-title__first">${current_title[i]}</span>`;
      } else {
        elements += `<br><span class="card-title__second">${current_title[i]}</span>`;
      }
    }
    
    return elements;
  }

  createHTMLListElement() {
    const recentlyViewedHtml = [];
    if (this.localStorageProducts === null) return;

    JSON.parse(this.localStorageProducts).map(item => {
      if(item.id !== this.product.id) {
      recentlyViewedHtml.unshift(`
        <li class="grid__item">
          <div class="card-wrapper product-card-wrapper underline-links-hover">
            <div class="card card--standard card--media" style="--ratio-percent: 150.00%;">  
              <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 150.00%;">
                <div class="card__media">
                  <div class="media media--transparent media--hover-effect">
                    <a href="${item.url}" class="full-unstyled-link"> 
                      <img class="recently-viewed-img" src='${item.image}' loading="lazy" alt="${item.title}"/>
                    </a>
                  </div>
                </div>
              </div>
              <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading h5">
                    <a class="full-unstyled-link center" href="${item.url}">
                      ${this.formatTitle(item.title)}
                    </a>
                  </h3>
                  <div class="card-information">
                    <div class="price">  
                      <div class="price__container">
                        <div class="price__regular">
                          <span>
                          <s class="price-item price-item--regular">
                          ${
                            item.comparePrice !== item.price
                              ? item.comparePrice !== ""
                                ? this.formatPrice(item.comparePrice)
                                : ''
                              : ''
                          }</s></span>
                          
                          <span class="price-item price-item--regular">
                            ${this.formatPrice(item.price)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      `);
    }});

    const products = `${recentlyViewedHtml.join("")}`;
    const productsGrid = document.getElementsByClassName("recently-viewed-grid");

    productsGrid[0].innerHTML = products;
  }
}

customElements.define("recently-viewed-products", RecentlyViewedProducts);
